import { UploadOptions } from "client/types/UploadOptions";
import { GoogleDriveIcon } from "components/common/Icons/GoogleDriveIcon";
import { Loader } from "components/common/Icons/Loader/Loader";
import { Translate } from "components/common/Translate/Translate";

export interface GoogleDriveUploadProps {
    options: UploadOptions;
    isLoading: boolean;
}

export const GoogleDriveUpload = ({ options, isLoading }: GoogleDriveUploadProps) => {
    return (
        <div
            className="flex items-center gap-2 py-3.5 pl-4 pr-12 hover:bg-gray-200 dark:bg-darkSurface-200 dark:hover:bg-darkSurface-300"
            onClick={(e) => {
                e.stopPropagation();
                options.onClick && options.onClick();
            }}
        >
            {isLoading ? (
                <Loader className="stroke-[var(--dark-gray)]" height={14} width={14} />
            ) : (
                <GoogleDriveIcon height={14} width={14} />
            )}
            <div className="capitalize">
                <Translate keyName="from-google-drive" />
            </div>
        </div>
    );
};
